import { RQ } from 'utils';
import config from 'config';
import { addClickAnalytics } from 'utils/analytics';

export default {
  /**
   * 检验是否领取优惠券
   * return {
   *   data: 0：可领取，1：已领取，2：不可以领取
   * }
   **/
  async checkReceiveCoupon () {
    const res = await RQ.mall.get('/api/app/coupon/getReceiveStatus', { couponType: 2 }, {loading: false});
    console.log('---------checkReceiveCoupon', res);
    if (res.code === 0) {
      this.received = res.data === 1;
    }
  },
  /**
   * 领取优惠券
   **/
  async receiveCoupon () {
    const res = await RQ.mall.post('/api/app/coupon/receiveByCouponType', { couponType: 2 }, {loading: false});
    console.log('-----------receiveCoupon', res);
    if (res.code === 0) {
      this.received = true;
      this.tips(res.msg);
    } else if (res.code === -30) {
      this.navToBindPhone();
    } else {
      this.tips(res.msg);
    }
    return res;
    // this.received = true;
  },
  navToBindPhone () {
    const { channel, enterprise, paramsNo } = this;
    const url = `${config.hosts.host}${this.$route.fullPath}`;
    if (window.__wxjs_environment === 'miniprogram') {
      // wxapp
      addClickAnalytics({ LogTitle: `跳转我的优惠券_wxapp_channel_${channel}` });
      wx.miniProgram.navigateTo({url: `/module/other/pages/validatePhone/index?from=webview&refresh=true&original=wxapp&channel=${channel}&enterprise=${enterprise}&url=${url}&paramsNo=${paramsNo}`});
    }
  },
  navToFlashSale () {
    const { channel, enterprise } = this;
    if (this.__canceling__ !== true) {
      this.__canceling__ = true;
      if (window.__wxjs_environment === 'miniprogram') {
        // wxapp
        addClickAnalytics({ LogTitle: `跳转抢购_wxapp_channel_${channel}` });
        wx.miniProgram.navigateTo({url: `/module/other/pages/flashSale/index?original=wxapp&channel=${channel}&enterprise=${enterprise}`});
      } else if (window.ReactNativeBridge) {
        // app
        addClickAnalytics({ LogTitle: `跳转抢购_app_channel_${channel}` });
        window.ReactNativeBridge.call('NAVIGATION', {
          id: 'FlashSale',
          params: {
            original: 'app', channel, enterprise
          },
          success: (res) => {
            console.log(res);
          },
          fail: (err) => {
            console.error(err)
          }
        })
      } else {
        addClickAnalytics({ LogTitle: `跳转抢购_h5_channel_${channel}` });
        if (this.isPlatform === 1) {
          window.location.href = 'http://leadmall-c.yolipai.net/meidd.html';
        }
      }
      setTimeout(() => {
        this.__canceling__ = false
      }, 1000)
    }
  },
  navToMyCoupon () {
    const { channel, enterprise } = this;
    if (this.__canceling__ !== true) {
      this.__canceling__ = true;
      if (window.__wxjs_environment === 'miniprogram') {
        // wxapp
        addClickAnalytics({ LogTitle: `跳转我的优惠券_wxapp_channel_${channel}` });
        wx.miniProgram.navigateTo({url: `/module/other/pages/coupon/index?original=wxapp&channel=${channel}&enterprise=${enterprise}`});
      } else if (window.ReactNativeBridge) {
        // app
        addClickAnalytics({ LogTitle: `跳转我的优惠券_app_channel_${channel}` });
        window.ReactNativeBridge.call('NAVIGATION', {
          id: 'Coupon',
          params: {
            original: 'app', channel, enterprise
          },
          success: (res) => {
            console.log(res);
          },
          fail: (err) => {
            console.error(err)
          }
        })
      } else {
        addClickAnalytics({ LogTitle: `跳转抢购_h5_channel_${channel}` });
        if (this.isPlatform === 1) {
          window.location.href = 'http://leadmall-c.yolipai.net/meidd.html';
        }
      }
      setTimeout(() => {
        this.__canceling__ = false
      }, 1000)
    }
  }
};



// WEBPACK FOOTER //
// ./src/module/app/coupon/action.js